// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header {
  height: 15vh;
  display: flex;
  align-items: center;
  justify-content: right;
}

.header-block {
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.header-icon {
  padding-right: 15px;
}

.header-block_userInfo {
  margin-left: 2em;
  display: flex;
  gap: 15px;
}

.header-user_img {
  width: 60px;
  height: 60px;
  object-fit: cover;
  border-radius: 50%;
}

.header-email {
  color: #b8b8b8;
}

@media screen and (max-width: 1050px) {
  .header {
    justify-content: right;
  }
}

@media screen and (max-width: 786px) {
  .header {
    margin-top: 10px;
    margin-bottom: 30px;
    height: 9vh;
    flex-direction: column;
  }

  .header-text {
    font-size: 20px;
  }

  .header-block {
    padding: 20px 0;
    width: 100%;
  }

  .header-user_info {
    font-size: 14px;
  }
}

@media screen and (max-width: 480px) {
  .header-icon {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Header/style.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,mBAAmB;IACnB,WAAW;IACX,sBAAsB;EACxB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF","sourcesContent":[".header {\n  height: 15vh;\n  display: flex;\n  align-items: center;\n  justify-content: right;\n}\n\n.header-block {\n  position: relative;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.header-icon {\n  padding-right: 15px;\n}\n\n.header-block_userInfo {\n  margin-left: 2em;\n  display: flex;\n  gap: 15px;\n}\n\n.header-user_img {\n  width: 60px;\n  height: 60px;\n  object-fit: cover;\n  border-radius: 50%;\n}\n\n.header-email {\n  color: #b8b8b8;\n}\n\n@media screen and (max-width: 1050px) {\n  .header {\n    justify-content: right;\n  }\n}\n\n@media screen and (max-width: 786px) {\n  .header {\n    margin-top: 10px;\n    margin-bottom: 30px;\n    height: 9vh;\n    flex-direction: column;\n  }\n\n  .header-text {\n    font-size: 20px;\n  }\n\n  .header-block {\n    padding: 20px 0;\n    width: 100%;\n  }\n\n  .header-user_info {\n    font-size: 14px;\n  }\n}\n\n@media screen and (max-width: 480px) {\n  .header-icon {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
